export default "__VITE_ASSET__BPSz5Xpc__"